<!-- <div *ngIf="role">
    <router-outlet></router-outlet>
</div> -->
<ngx-spinner
bdColor = "rgba(255, 255, 255, 0.8)"
size = "default"
color = "#76C04D"
text = "Loading..."
type = "line-scale"></ngx-spinner>
<app-loader></app-loader>
<div>
    <app-header *ngIf="headerFooter"></app-header>
    <div style="min-height: 371px;">
        <router-outlet></router-outlet>

    </div>
    <app-footer *ngIf="headerFooter"></app-footer>
</div>
